import { useEffect, useState, useRef } from 'react';
import { browserHistory } from '../../../../App';

import { useUtils } from '../../../../core/hooks/useUtils';
import { startSyncAction } from '../../../../store/Auth/action';
import { getMyTeamAction } from '../../../../store/MyTeam/action';

interface IOutput {
	loader: number;
}

interface IInput {
	callback(): void;
}

interface HookState {
	loader: number;
}

export default function useHook({ callback }: IInput): IOutput {
	const timeout = useRef<any>(null);
	const {
		dispatch,
		store: { myTeam },
	} = useUtils();

	const [state, setState] = useState<HookState>({
		loader: 0,
	});

	useEffect(() => {
		setInitial();
		dispatch(startSyncAction());
		return () => clearInterval(timeout.current);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (myTeam.data) {
			if (myTeam.data?.synchronizationPercentage >= 100) {
				clearInterval(timeout.current);
				browserHistory.push('/my-boards');
			}
			setState(prev => ({
				...prev,
				loader: myTeam.data ? myTeam.data.synchronizationPercentage : 0,
			}));
		} else {
			setState(prev => ({ ...prev, loader: 0 }));
		}
	}, [myTeam.data]);

	const setInitial = async () => {
		if (loader <= 100) {
			timeout.current = setInterval(async () => {
				dispatch(getMyTeamAction());
			}, 3000);
		} else {
			setState(prev => ({ ...prev, loader: 100 }));
			browserHistory.push('/my-boards');
		}
	};

	const { loader } = state;

	return {
		loader,
	};
}
